import React from 'react';
import { cn } from '../constants/theme';

interface ThemeToggleProps {
  dark: boolean;
  onToggle: () => void;
  size?: 'sm' | 'md';
}

export function ThemeToggle({ dark, onToggle, size = 'md' }: ThemeToggleProps) {
  const sizeClasses = size === 'sm' ? 'h-9 w-9' : 'h-10 w-10';
  const iconSize = size === 'sm' ? 'text-[24px]' : 'text-[28px]';

  return (
    <button
      onClick={onToggle}
      className={cn(
        'flex items-center justify-center rounded transition-colors',
        sizeClasses,
        dark
          ? 'bg-[#283539] text-white hover:bg-[rgba(84,212,248,0.2)]'
          : 'bg-slate-200 text-slate-900 hover:bg-[rgba(84,212,248,0.2)]',
        size === 'sm' && 'border',
        size === 'sm' && dark && 'border-slate-800 bg-[#0f1b1f]',
        size === 'sm' && !dark && 'border-slate-200 bg-white'
      )}
      type="button"
      aria-label="Toggle theme"
    >
      <span className={cn('material-symbols-outlined leading-none', iconSize)}>
        light_mode
      </span>
    </button>
  );
}
